import Vue from 'vue'
import Router from 'vue-router'
import homeRouter from './home.router.js'
import courseRouter from './course.router.js'
import actRouter from './act.router.js'
import meRouter from './me.router.js'
import loginRouter from './login.router'
import shareRouter from './share.router.js'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    ...homeRouter,
    ...courseRouter,
    ...actRouter,
    ...meRouter,
    ...loginRouter,
      ...shareRouter
  ]
})
const originalReplace = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
}
export default router
